import { AnimatePresence } from "framer-motion";
import { useInquiryForm } from "./InquiryForm/useInquiryForm";
import InquirySuccess from "./InquiryForm/InquirySuccess";
import InquiryFields from "./InquiryForm/InquiryFields";

export default function InquiryForm() {
    const { form, errors, status, submitError, setField, onSubmit, reset } =
        useInquiryForm();

    return (
        <AnimatePresence mode="wait">
            {status === "success" ? (
                <InquirySuccess onReset={reset} />
            ) : (
                <InquiryFields
                    form={form}
                    errors={errors}
                    status={status}
                    submitError={submitError}
                    setField={setField}
                    onSubmit={onSubmit}
                />
            )}
        </AnimatePresence>
    );
}
